import { ActionCreator, Action, Dispatch } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { IApplicationState } from '../store'
import GlnService from 'shared/service/GlnService'
import { VestigingEnum } from 'shared/models/Enum'
import { IKlant } from 'shared/models/IKlant'
import { IResponseAction } from '../interfaces'

export enum Actions {
  ClearDataRequest = 'ClearDataRequest',
  ClearDataResponse = 'ClearDataResponse',
  GetDataRequest = 'GET_DATA_REQUEST',
  GetDataResponse = 'GET_DATA_RESPONSE',
  GetDataFoutResponseAction = 'GetDataFoutResponseAction',
  SetWarehouseAction = 'SetWarehouseAction',
}

export interface IClearDataRequestAction
  extends Action<Actions.ClearDataRequest> {}
export interface IClearDataResponseAction
  extends IResponseAction<Actions.ClearDataResponse> {
  payload: string
}
export interface IGetDataRequestAction extends Action<Actions.GetDataRequest> {
  payload: VestigingEnum
}
export interface IGetDataResponseAction
  extends IResponseAction<Actions.GetDataResponse> {
  payload: IKlant[]
}
export interface ISetWarehouseAction
  extends Action<Actions.SetWarehouseAction> {
  payload: VestigingEnum
}

export type KoppelingenVestigingenActions =
  | IClearDataRequestAction
  | IClearDataResponseAction
  | IGetDataRequestAction
  | IGetDataResponseAction
  | ISetWarehouseAction

export const clearDataActionCreator: ActionCreator<
  ThunkAction<
    Promise<IClearDataResponseAction>,
    IApplicationState,
    null,
    IClearDataResponseAction
  >
> = (message: string) => {
  return async (dispatch: Dispatch, getState) => {
    const requestClearAction: IClearDataRequestAction = {
      type: Actions.ClearDataRequest,
    }
    dispatch(requestClearAction)
    const clearResponse: IClearDataResponseAction = {
      success: true,
      type: Actions.ClearDataResponse,
      payload: message,
    }
    return dispatch(clearResponse)
  }
}

export const getDataActionCreator: ActionCreator<
  ThunkAction<
    Promise<IGetDataResponseAction>,
    IApplicationState,
    null,
    IGetDataResponseAction
  >
> = (selectie: VestigingEnum) => {
  return async (dispatch: Dispatch, getState) => {
    const requestDataAction: IGetDataRequestAction = {
      type: Actions.GetDataRequest,
      payload: selectie,
    }
    dispatch(requestDataAction)

    if (selectie > 0) {
      try {
        const result = await GlnService.getKoppelingenPerVestiging(selectie)
        const response: IGetDataResponseAction = {
          success: result.success,
          errorMessage: result.errorMessage,
          payload: result.payLoad,
          type: Actions.GetDataResponse,
        }

        if (
          (!result.success && result.errorCode === 404) ||
          (result.success && result.payLoad.length === 0)
        ) {
          response.success = false
          response.errorMessage = 'Geen koppelingen gevonden'
        }

        return dispatch(response)
      } catch (e) {
        const errorResponse: IGetDataResponseAction = {
          success: false,
          errorMessage: `Fout bij het ophalen van de koppelingen: ${e.message}`,
          payload: null,
          type: Actions.GetDataResponse,
        }

        return dispatch(errorResponse)
      }
    } else {
      const failResponse: IGetDataResponseAction = {
        success: false,
        errorMessage: 'Geen geldige vestiging gekozen',
        payload: null,
        type: Actions.GetDataResponse,
      }

      return dispatch(failResponse)
    }
  }
}

export const setWarehouseActionCreator: ActionCreator<
  ThunkAction<
    Promise<ISetWarehouseAction>,
    IApplicationState,
    null,
    ISetWarehouseAction
  >
> = (warehouse: VestigingEnum) => {
  return async (dispatch: Dispatch, getState) => {
    const response: ISetWarehouseAction = {
      type: Actions.SetWarehouseAction,
      payload: warehouse,
    }
    return dispatch(response)
  }
}
